<section class="icip-final" aria-label="Final call to action">
  <div class="icip-final__grid" aria-hidden="true"></div>
  <div class="icip-final__rule" aria-hidden="true"></div>

  <div class="icip-final__container icip-reveal" appInView>
    <div class="icip-final__badge">
      <span class="icip-final__badge-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none">
          <path d="M22 16.92V19a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 3 4.18 2 2 0 0 1 5 2h2.09a2 2 0 0 1 2 1.72c.12.86.33 1.7.62 2.51a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.57-1.57a2 2 0 0 1 2.11-.45c.81.29 1.65.5 2.51.62A2 2 0 0 1 22 16.92Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>
      International Branded Calling
    </div>

    <h2 class="icip-final__title">
      Launch International Branded Calling
      <br />
      <span class="icip-final__title-muted">with Confidence.</span>
    </h2>

    <p class="icip-final__subtitle">
      Join enterprise operators already managing international caller ID at scale, through a single, carrier-connected platform.
    </p>

    <div class="icip-final__ctas">
      <button type="button" class="icip-final__cta-primary" (click)="planPrompt.open()">
        Get Started
        <svg class="icip-final__cta-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          <path d="M13 6L19 12L13 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      <button type="button" class="icip-final__cta-secondary" (click)="talkToSales.requestOpen()">
        Talk to Sales
      </button>
    </div>

    <p class="icip-final__trust">
      Enterprise onboarding · SLA-backed availability · Carrier-direct connectivity
    </p>
  </div>
</section>
